const elegislativaPrefixPath = '/external/elegislativa';
const publikatorPrefixPath = '/external/publikator-ezbierky';
const evidenciaPrefixPath = '/external/evidencna-aplikacia';

export { elegislativaPrefixPath, publikatorPrefixPath, evidenciaPrefixPath };
